<template>
  <b-container fluid>
    <b-row no-gutters>

      <b-col v-if="dataFiles.length<5" class="upload-box-col">
        <file-upload-launcher 
          hint="Click Here to take pictures or upload from gallery"
          accept="*"
          is-multiple="true"
          @selected-files="selectedFiles">
        </file-upload-launcher>
      </b-col>

      <b-col class="upload-box-col"
          v-for="file in dataFiles"
          :key="'other_' + file.objectId">

        <file-uploader
          ref="fileUploader"
          :consult-uid="consultUid"
          :object-id="file.objectId" 
          :attach-type="file.type"
          @upload-selected="selectedOneFile"
          accept=""
          class="file-uploader">
        </file-uploader>
      </b-col>

    </b-row>
  </b-container>
</template>

<script>
import Vue from 'vue';
import { debug, defineString, bytesToSize } from './globals';

import FileUploader from './FileUploader';
import FileUploadLauncher from './FileUploadLauncher';


require('formdata-polyfill'); // for FormData in IE11


const MAX_FILE_SIZE = 10485760; //5242880;

export default {
  // props: {
  //   consultUid: { type: String },
  // },


  components: {
    FileUploader,
    FileUploadLauncher,
  },

  
  data: function() {
    return {
      canWatch: false,
      uploadFormData: {},
    }
  },

  computed: {
    images: function() {
      return this.$store.getters['form/images']
    },

    dataFiles: function() {
      return this.$store.getters['form/images']
        .filter(i => (i.objectId!='photo' && i.objectId.substr(0, 3)!='mi_'))
    },

    consultUid() {
      return this.$store.getters['form/consultUid']
    }
  },


  created() {
    debug('OtherDataBox created');

    this.canWatch = false;

    this.canWatch = true;
    debug('OtherDataBox created: done');
  },



  methods: {
    getNextUploadId(images) {
      var tryUploadId = '';
      var foundUnique = false;
      var i = 1;
      while (!foundUnique) {
        tryUploadId = 'other_data_upload_' + i;
        const indexFound = images.findIndex(im => im.objectId === tryUploadId);
        if (indexFound == -1) {
          foundUnique = true;
        }
        i++
      }
      return tryUploadId
    },


    selectedFiles(data) {
      debug('OtherDataBox selectedFiles ----------------------------------------');
      // const vm = this;

      var fieldName = data.fieldName;
      var fileList = data.fileList;
      debug('OtherDataBox selectedFiles: source=' + fieldName);

      const totalFiles = this.dataFiles.length + fileList.length;
      if (totalFiles > 5) {
        alert("No more than 5 files can be uploaded.");
        return;
      }

      for (var j = 0; j < fileList.length; j++) {
        var oneFile = fileList.item(j);
        if (oneFile.size > MAX_FILE_SIZE) {
          const strSize = bytesToSize(MAX_FILE_SIZE);
          alert("File size of \"" + oneFile.name + "\" exceeds the " + strSize + " limit.\nPlease select a smaller file.")
          return;
        }
      }



      // loop through files
      for (var i = 0; i < fileList.length; i++) {
        // get item
        var file1 = fileList.item(i);
        debug('OtherDataBox selectedFiles: ' + i + ' >>>>>>>>>>>>>>>>>>>>>> ' + file1.name);

        // make sure newUploadId is unique!
        const newUploadId = this.getNextUploadId(this.images);
        debug('OtherDataBox selectedFiles: NEW uploadId = ' + newUploadId);

        var formData = new FormData();
        formData.append('ufile', file1, file1.name);
        formData.append('suid', defineString(this.consultUid));
        formData.append('upload_id', defineString(newUploadId));
        formData.append('type', 'auto'); // ?
        formData.append('descr', file1.name); // ?
        formData.append('ser', '');
        formData.append('num', 'num'); 

        debug('OtherDataBox selectedFiles: file1: ' + file1.name + ', new uploadId=' + newUploadId);

        // // insert/update images => watch will trigger upload
        debug('OtherDataBox selectedFiles: dispatch form/setSingleImageData for ' + newUploadId);
        this.$store.dispatch('form/setSingleImageData',
          { objectId: newUploadId,
            attachType: 'auto',
            uploadId: newUploadId,
            fileName: file1.name,
            contentType: file1.type,
            descr: file1.name,
            ser: '',
            num: '',
          });

        this.doUpload(newUploadId, formData)
      }
    },



    // one file
    selectedOneFile(data) {
      // upload ID is known if we are here!
      
      debug('OtherDataBox selectedOneFile ----------------------------------------');
      // const vm = this;

      // var fieldName = data.fieldName;
      // var fileList = data.fileList;
      var file1 = data.fileList.item(0);
      const uploadId = data.objectId; // ?

      debug('OtherDataBox selectedOneFile: >>>>>>>>>>> '
        + 'uploadId=' + uploadId + ', ' + file1.name);

      // make sure newUploadId is unique!
      // const newUploadId = this.getNextUploadId(this.images);
      // debug('OtherDataBox selectedOneFile: NEW uploadId = ' + newUploadId);

      var formData = new FormData();
      formData.append('ufile', file1, file1.name);
      formData.append('suid', defineString(this.consultUid));
      formData.append('upload_id', defineString(uploadId));
      formData.append('type', 'auto'); // ?
      formData.append('descr', file1.name); // ?

      debug('OtherDataBox selectedOneFile: launch upload for ' + uploadId);
      this.doUpload(uploadId, formData)
    },



    doUpload(uploadId, formData) {
      const vm = this;
      Vue.nextTick(function() {
        debug('OtherDataBox doUpload: ================ call upload for ' + uploadId);
        vm.$refs.fileUploader.find(i => i.objectId == uploadId).upload(formData)
      });
    },
  }, // methods
}
</script>

<style scoped>

.file-upload-launcher {
  width: 200px;
  margin: 2px;
  height: 200px;
}


.upload-box-col {
  padding: 2px;
}

</style>